import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
let pending = null;

export default function useResidenceMeta() {
  const [meta, setMeta] = useState(cache);
  useEffect(() => {
    if (cache) { return; }
    pending = pending || api.get("/residences/meta").then((r) => { cache = r.data; return r.data; });
    pending.then(setMeta).catch(() => {});
  }, []);
  return meta;
}
